export enum DsFormTypeEnum {
  SECTION = 'SECTION',
  BOOLEAN = 'BOOLEAN',
  TEXT = 'TEXT',
  TEXTAREA = 'TEXTAREA',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  RADIO = 'RADIO',
  LISTBOX = 'LISTBOX',
  CHOICE = 'CHOICE',
  SIGNATURE = 'SIGNATURE',
  DYNAMIC_TABLE = 'DYNAMIC_TABLE',
  STATIC_TABLE = 'STATIC_TABLE',
  PHOTO = 'PHOTO',
  DOCUMENT = 'DOCUMENT',
}
